"use client";

import SwiperCore from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

SwiperCore.use([Autoplay, Navigation]);

import { StrapiMedia } from "@/types";
import StrapiImage from "@/components/StrapiComponents/StrapiImage";

import NavIconLeft from "@/app/svg/NavIconLeft";
import NavIconRight from "@/app/svg/NavIconRight";

import galleryStyle from "@/styles/Gallery.module.scss";
import "@/styles/Gallery.scss";
import { useId } from "react";
import { ImageLoader } from "./ImageLoader";

export const ImageGallery = ({ images }: { images: StrapiMedia[] | null }) => {
	const uniqueId = useId().replace(/[:]/g, "-");

	if (images === null) {
		return null;
	}

	const pagination = {
		clickable: true,
		renderBullet: function (index: number, className: string) {
			return `<button aria-label="Springe zu Bild ${index + 1} von ${images?.length}" class="${className}"></button>`;
		},
	};

	return (
		<Swiper
			pagination={pagination}
			modules={[Pagination]}
			spaceBetween={50}
			centeredSlides={true}
			slidesPerView={1}
			autoHeight={false}
			loop={true}
			autoplay={{
				delay: 6000,
				disableOnInteraction: true,
			}}
			navigation={{
				nextEl: `.${uniqueId}-gallery-next`,
				prevEl: `.${uniqueId}-gallery-prev`,
			}}
		>
			{images.map((imageObject) => {
				return (
					<SwiperSlide key={imageObject.id}>
						<div className={galleryStyle.content}>
							<figure className={galleryStyle.figure}>
								<ImageLoader />
								<StrapiImage media={imageObject} className={galleryStyle.image} format="large" loadingType="lazy" />
								{imageObject.caption && <figcaption className={`${galleryStyle.caption} translate`}>{imageObject.caption}</figcaption>}
							</figure>
						</div>
					</SwiperSlide>
				);
			})}

			<nav className={galleryStyle.galleryNav}>
				<button title="vorheriges Bild" className={`${uniqueId}-gallery-prev ${galleryStyle.galleryNavButton} ${galleryStyle.galleryNavButtonLeft}`}>
					<NavIconLeft />
				</button>
				<button title="nächstes Bild" className={`${uniqueId}-gallery-next ${galleryStyle.galleryNavButton} ${galleryStyle.galleryNavButtonRight}`}>
					<NavIconRight />
				</button>
			</nav>
		</Swiper>
	);
};
